import { CFormSelect } from '@coreui/react';
import { useMemo } from 'react';

import { useLocationStore, usePrismicStore, useProfessionalsStore } from '@/zustandStore.js';

const ProfessionalSelection = ({ selectedProfessional, setSelectedProfessional, disabled = false }) => {
    const professionals = usePrismicStore((state) => state.professionals);
    const selectedLocation = useLocationStore((state) => state.selectedLocation);
    const cachedUserData = useProfessionalsStore((state) => state.cachedUserData);
    const lightMappings = useProfessionalsStore((state) => state.lightMappings);

    const instanceIdSet = new Set(selectedLocation?.instanceIds);
    const hubIdSet = new Set((selectedLocation?.configs ?? []).map((config) => config.hub.id));

    const professionalMappings = useMemo(() => {
        if (!cachedUserData || !lightMappings) return undefined;

        const enrichedLightMappings = Object.values(lightMappings).map((mapping) => ({
            ...mapping,
            instanceId: mapping.dc_instance_id,
        }));

        const mappings = {};
        for (const user of [...cachedUserData, ...enrichedLightMappings]) {
            mappings[user.prismic_key] = user;
        }

        return mappings;
    }, [cachedUserData, lightMappings]);

    const professionalOptions = useMemo(() => {
        const options = Object.keys(professionals)
            .filter(
                (key) =>
                    instanceIdSet.has(professionalMappings[key]?.instanceId) &&
                    hubIdSet.has(professionals[key].location_hub.id)
            )
            .sort((a, b) => professionals[a].display_name[0].text.localeCompare(professionals[b].display_name[0].text))
            .map((professional) => {
                return {
                    label: professionals[professional].display_name[0].text,
                    value: professionals[professional].key[0].text,
                };
            });

        return options;
    }, [professionals, professionalMappings, instanceIdSet, hubIdSet]);

    return (
        <CFormSelect
            disabled={disabled}
            options={[{ label: 'Professional auswählen', value: '-' }, ...professionalOptions]}
            value={selectedProfessional}
            onChange={(e) => setSelectedProfessional(e.target.value)}
            name="professionalSelect"
        />
    );
};

export default ProfessionalSelection;
